<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">회원 관리</a> &gt; <strong>회원 리스트</strong></div>
			<h2 class="h_sub">회원 등록</h2>
		</div>

    <AccountManageCreateForm/>
  </div>
</template>

<script>
import AccountManageCreateForm from '@/components/admin/account/AccountManageCreateForm.vue';

export default {
  components: {
    AccountManageCreateForm
  }
}
</script>
<style lang="">
    
</style>